import { cn } from "@/lib/utils";

export interface CarouselIndicatorProps {
  currentIndex: number;
  total: number;
  className?: string;
}

export const CarouselIndicator = ({
  currentIndex,
  total,
  className,
}: CarouselIndicatorProps) => {
  const pillHeight = 100 / total;
  const translateY = (currentIndex - 1) * 100;

  return (
    <div
      className={cn(
        "pointer-events-none w-4 min-h-16 h-[22.5%] max-h-32 p-1 rounded-full bg-neutral-900/20 backdrop-blur-md glass-border",
        className,
      )}
    >
      <div
        className="rounded-[2.5rem] w-full bg-neutral-50 transition-all duration-300 ease-in-out"
        style={{
          height: `${pillHeight}%`,
          transform: `translateY(${translateY}%)`,
        }}
      />
    </div>
  );
};
